export const Kpi = ({ label, value, testid }) => (
  <div className="rounded-2xl bg-white border border-sky-100 p-5" data-testid={testid}>
    <p className="font-display text-3xl text-[#03045E]">{value}</p>
    <p className="text-xs uppercase tracking-wider font-bold text-slate-500 mt-1">{label}</p>
  </div>
);

export const Panel = ({ title, children, action, testid }) => (
  <div className="rounded-3xl bg-white border border-sky-100 p-5 md:p-6" data-testid={testid}>
    <div className="flex justify-between items-center gap-3 mb-4"><p className="font-display uppercase text-xl text-[#03045E]">{title}</p>{action}</div>
    {children}
  </div>
);

export const Table = ({ cols, rows, empty = "Nothing here yet.", testid }) => (
  <div className="overflow-x-auto" data-testid={testid}>
    <table className="w-full text-sm">
      <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b">{cols.map((c) => <th key={c} className="py-2 pr-4 font-bold whitespace-nowrap">{c}</th>)}</tr></thead>
      <tbody>{rows.length ? rows : <tr><td colSpan={cols.length} className="py-6 text-center text-slate-500">{empty}</td></tr>}</tbody>
    </table>
  </div>
);

export const Td = ({ children, className = "" }) => <td className={`py-2.5 pr-4 align-top ${className}`}>{children}</td>;

export const NavyBtn = ({ children, className = "", ...p }) => (
  <button {...p} className={`rounded-full bg-[#03045E] hover:bg-[#0077B6] text-white px-4 py-2 text-xs font-bold uppercase transition-colors duration-200 disabled:opacity-50 ${className}`}>{children}</button>
);
